import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from '../../../header/Header';
import MainContent from '../MainContent/MainContent';
import { MainHeader } from '../MainHeader/MainHeader';
import MainSider from '../sider/MainSider/MainSider';
import {
  MEDICAL_DASHBOARD_PATH,
  NFT_DASHBOARD_PATH,
  ALL_PATHS,
  HOME_PATH,
  FISHING_INSPECTIONS_PATH,
} from '@app/constants/routerPaths';
import { useResponsive } from '@app/hooks/useResponsive';
import { TemporaryPasswordBanner } from '@app/components/common/TemporaryPasswordBanner/TemporaryPasswordBanner';
import { ErrorBoundary } from '@app/components/common/ErrorBoundary/ErrorBoundary';
import * as S from './MainLayout.styles';

const MainLayout: React.FC = () => {
  const [isNoOffsetMainContent, setIsNoOffsetMainContent] = useState(false);
  const [isTwoColumnsLayout, setIsTwoColumnsLayout] = useState(true);
  const [isFishingInspectionPage, setIsFishingInspectionPage] = useState(false);
  const [siderCollapsed, setSiderCollapsed] = useState(true);
  const { isDesktop, isTablet, isBigScreen } = useResponsive();
  const location = useLocation();

  const toggleSider = () => setSiderCollapsed(!siderCollapsed);

  useEffect(() => {
    setIsTwoColumnsLayout([MEDICAL_DASHBOARD_PATH, NFT_DASHBOARD_PATH].includes(location.pathname) && isDesktop);
  }, [location.pathname, isDesktop]);

  useEffect(() => {
    // Only apply to fishing inspection detail pages (with IDs), not the main list page
    const isFishingInspectionDetailPage =
      location.pathname.startsWith(FISHING_INSPECTIONS_PATH) && location.pathname !== FISHING_INSPECTIONS_PATH;
    setIsFishingInspectionPage(isFishingInspectionDetailPage);
  }, [location.pathname]);

  useEffect(() => {
    const val =
      [...ALL_PATHS.filter((path) => path !== HOME_PATH)].includes(location.pathname) &&
      [isTablet, isBigScreen, isDesktop].some((val) => val);

    setIsNoOffsetMainContent(val);
  }, [location.pathname, isTablet, isBigScreen, isDesktop]);

  return (
    <S.LayoutMaster>
      <MainSider isCollapsed={siderCollapsed} setCollapsed={setSiderCollapsed} />
      <S.LayoutMain>
        <TemporaryPasswordBanner />
        <MainHeader isTwoColumnsLayout={isTwoColumnsLayout}>
          <Header toggleSider={toggleSider} isSiderOpened={!siderCollapsed} isTwoColumnsLayout={isTwoColumnsLayout} />
        </MainHeader>
        <MainContent
          id="main-content"
          $isTwoColumnsLayout={isTwoColumnsLayout}
          $isNoOffsetMainContent={isNoOffsetMainContent}
          $isFishingInspectionPage={isFishingInspectionPage}
        >
          {/* Keyed on the path: React never resets a boundary that has caught. */}
          <ErrorBoundary key={location.pathname}>
            <Outlet />
          </ErrorBoundary>
        </MainContent>
      </S.LayoutMain>
    </S.LayoutMaster>
  );
};

export default MainLayout;
